import { Props } from "./types";
import classNames from "classnames";
import DataContainer from "../../services/DataContainer";
import { ContactDealerFormSettings } from "../../enum/enums";

export const SalesforceInput = ({
  type,
  value,
  isRequired,
  onChangeEvent,
  name,
  label,
  checked,
  onKeyDownEvent,
  onClickEvent,
  customClassNames,
  placeholder
}: Props) => {

  return (
    <div className={`${customClassNames} relative flex flex-col gap-1 justify-end cursor-pointer w-full`}>
      <label
        className={"font-bold text-sm text-[#575757]"}
        htmlFor={name}
      >
        {label}
      </label>
      <input
        id={name}
        type={type}
        placeholder={placeholder}
        onWheel={(e) => (e.target as HTMLInputElement).blur()}
        className={classNames(
          "rounded border h-10 border-[#A9A9A9] pl-3 pr-1 py-1 text-base text-[#575757] hover:border-[#4781C4] focus:outline-none focus:ring-2 focus:ring-[#4781C4]",
          { "!border-red": (isRequired && value === "")},
        )}
        value={value}
        onChange={onChangeEvent}
        onClick={onClickEvent}
        name={name}
        checked={checked}
        onKeyDown={onKeyDownEvent}
        required={isRequired}
      />
      {(isRequired && value === "") && (
        <span className="text-red text-xl h-4">{DataContainer.sectionKey(ContactDealerFormSettings.CONTACT_DEALER_FORM,`contact_dealer_${name}_required_text`)}</span>
      )}
    </div>
  );
};
